module.exports = __webpack_public_path__ + "static/img/ms.3661f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ms.png
// module id = 2vSf
// module chunks = 23